import { styled } from "@mui/system";

export const ThComponent = styled("th")`
  color: ${(props: any) => props.theme.table.colors.tHeadFontColor};
  font-size: 14px;

  padding: 15px 20px 15px 20px;
`;
